'use client';

import { SidebarItemProps, useSidebarStore } from '@/hooks/use-sidebar-store';
import { cn } from '@/lib/utils';
import { memo } from 'react';

const MAXIMUM_COUNT = 999;

export const CustomSidebarCounter = memo(
    ({ item, className }: { item: SidebarItemProps; className?: string }) => {
        const objCount = useSidebarStore((x) => x.objCounter);
        const count = objCount[item.href ?? ''];

        if (!count) return <></>;

        return (
            <span
                className={cn(
                    'ml-auto mr-1 flex h-5 min-w-5 items-center justify-center rounded-md px-1 text-[11px] font-medium',
                    className
                )}
            >
                {count > MAXIMUM_COUNT ? `${MAXIMUM_COUNT}+` : count}
            </span>
        );
    }
);

CustomSidebarCounter.displayName = 'CustomSidebarCounter';
